import { render, staticRenderFns } from "./Overviewitemcomponents.vue?vue&type=template&id=540233dd&scoped=true&"
import script from "./Overviewitemcomponents.vue?vue&type=script&lang=js&"
export * from "./Overviewitemcomponents.vue?vue&type=script&lang=js&"
import style0 from "./Overviewitemcomponents.vue?vue&type=style&index=0&id=540233dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540233dd",
  null
  
)

export default component.exports